import { useSaveUnknownFund as useSaveUnknownFundRequest } from "src/services/admin/commands/unknownSecurities";
import SnackbarUtils from "src/utils/SnackbarUtils";

import { UnknownFund } from "../../types";

export const useSaveUnknownFund = () => {
	const onSuccess = () => {
		SnackbarUtils.success("Se ha guardado el fondo.");
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar guardar el fondo.");
	};

	const { mutate, isPending } = useSaveUnknownFundRequest(onSuccess, onError);

	const onSave = (unknownFund: UnknownFund) => {
		mutate(unknownFund, { onSuccess, onError });
	};

	return { onSave, isLoading: isPending };
};
